<template>
  <div class="course-plans-wrapper">
    <div
      class="head d-flex align-items-center cursor-pointer"
      @click="$emit('toggleVisible', !toggleAllPlansVisible)"
    >
      <i class="icon-Book text-24 mr-2"></i>
      <span class="font-weight-bold"> {{ $t('我的課程') }}</span>
    </div>
    <div class="course-plans-list scroll-bar">
      <CourseTypeCollapse
        @change-course="changeCourse"
        @favorite-course="favoriteCourse"
      ></CourseTypeCollapse>
    </div>
  </div>
</template>

<script>
import CourseTypeCollapse from '@/components/Base/CourseTypeCollapse';

export default {
  components: {CourseTypeCollapse},
  props: {
    toggleAllPlansVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    plans() {
      return this.$store.getters['course/plans'];
    },
  },
  methods: {
    changeCourse(course) {
      this.$emit('change-course', course);
    },
    favoriteCourse(course) {
      this.$emit('favorite-course', course);
    },
  },
};
</script>

<style lang="scss" scoped>
.course-plans-wrapper {
  height: calc(100% - 78px);
  border: 1px solid #dcdfe5;
  .head {
    color: $font-grayscale-1;
    padding: 0 16px;
    background: $grayscale-2;
    height: 50px;
  }
  .course-plans-list {
    height: calc(100% - 50px - 16px);
    padding: 8px;
    overflow: auto;
  }
}
</style>
